import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import LocationTabState from 'samples/locations/LocationTabState';
import LocationViewContainer from 'samples/locations/LocationViewContainer';

export default class LocationTabView extends Backbone.View<LocationTabState> {
  render(): Backbone.View<LocationTabState> {
    renderToDOM(<LocationViewContainer locationId={this.model.get('id')} />, this.el);
    return this;
  }

  remove(): Backbone.View<LocationTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

LocationTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
